export const NEWS_IMAGE_RESOURCE_NAME = 'News Image';

export const UPLOAD_NEWS_IMAGE = 'UPLOAD_NEWS_IMAGE';
export const UPLOAD_NEWS_IMAGE_LOADING = 'UPLOAD_NEWS_IMAGE_LOADING';
export const UPLOAD_NEWS_IMAGE_SUCCESS = 'UPLOAD_NEWS_IMAGE_SUCCESS';
export const UPLOAD_NEWS_IMAGE_FAILURE = 'UPLOAD_NEWS_IMAGE_FAILURE';

export const uploadNewsImageBackendPath = '/backend/news/upload/image/';

export const uploadNewsImage = (data, cancelPrevious = true) => ({
  type: UPLOAD_NEWS_IMAGE,
  payload: { data },
  meta: { httpMethod: 'POST', apiPath: uploadNewsImageBackendPath, cancelPrevious }
});


// WEBPACK FOOTER //
// ./src/actions/news/index.js